import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { IBin } from './bin';
import { BinesService } from './bines.service';
import { BinListComponent } from './bin-list.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
// import * as myGlobals from './../global';
// import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { NaturalezaContable } from './naturaleza-contable';
import { NaturalezasContableService } from './naturaleza-contable.service';
import { TarjetasService } from '../tarjetas/tarjetas.service';
import { EmisoresService } from '../emisores/emisores.service';
import { ITarjeta } from '../tarjetas/tarjeta';
import { IEmisor } from '../emisores/emisor';
import { HttpErrorValidator } from '../services/http-error-validator';

@Component({
  selector: 'pm-bin',
  templateUrl: './bin.component.html',
  styleUrls: ['./bin.component.sass']
})
export class BinComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'BINES';

  bines: IBin[] = [];
  filteredBines: IBin[];
  errorMessage = '';
  currentPg = 1;

  private _searchPrefix = '';
  private _searchAccountingNature = '';
  private _searchCardBrand = '';
  private _searchCardIssuer = '';
  private _searchStatus = '';

  accountingNatureList: Observable<NaturalezaContable[]> = this.accountingNatureService.allRecords();
  cardBrandList: Observable<ITarjeta[]> = this.tarjetasService.getTarjetas();
  cardIssuerList: Observable<IEmisor[]> = this.emisoresService.getEmisores();

  constructor(
    public service: BinesService,
    private parent: BinListComponent,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private accountingNatureService: NaturalezasContableService,
    private tarjetasService: TarjetasService,
    private emisoresService: EmisoresService,
    private httpErrorValidator: HttpErrorValidator
  ) {}

  ngAfterViewInit() {
    // $('#menu-catalogos').click();
    $('a[rel=bines]').addClass('selected');
  }

  get searchPrefix(): string {
    return this._searchPrefix;
  }

  set searchPrefix(value: string) {
    console.log('searchPrefix: _searchPrefix: ', value);
    // console.log('searchPrefix: _searchPrefix: ', this._searchPrefix);
    console.log('searchPrefix: _searchAccountingNature: ', this._searchAccountingNature);
    console.log('searchPrefix: _searchCardBrand: ', this._searchCardBrand);
    console.log('searchPrefix: _searchCardIssuer: ', this._searchCardIssuer);
    console.log('searchPrefix: _searchStatus: ', this._searchStatus);
    this._searchPrefix = value;
    const filters = {
      prefix: [this._searchPrefix], // ['Blue', 'Black'],
      accountingNature: [this._searchAccountingNature], // [70, 50]
      cardBrand: [this._searchCardBrand],
      cardIssuer: [this._searchCardIssuer],
      status: [this._searchStatus]
    };
    this.filteredBines = this.filterBines();
  }

  get searchAccountingNature(): string {
    return this._searchAccountingNature;
  }

  set searchAccountingNature(value: string) {
    // console.log('searchAccountingNature: _searchPrefix: ', this._searchPrefix);
    // console.log('searchAccountingNature: _searchAccountingNature: ', value);
    // console.log('searchAccountingNature: _searchCardBrand: ', this._searchCardBrand);
    // console.log('searchAccountingNature: _searchCardIssuer: ', this._searchCardIssuer);
    // console.log('searchAccountingNature: _searchStatus: ', this._searchStatus);
    this._searchAccountingNature = value;
    const filters = {
      prefix: [this._searchPrefix], // ['Blue', 'Black'],
      accountingNature: [this._searchAccountingNature], // [70, 50]
      cardBrand: [this._searchCardBrand],
      cardIssuer: [this._searchCardIssuer],
      status: [this._searchStatus]
    };
    this.filteredBines = this.filterBines();
  }

  get searchCardBrand(): string {
    return this._searchCardBrand;
  }

  set searchCardBrand(value: string) {
    // console.log('searchCardBrand: _searchPrefix: ', this._searchPrefix);
    // console.log('searchCardBrand: _searchAccountingNature: ', this._searchAccountingNature);
    // console.log('searchCardBrand: _searchCardBrand: ', value);
    // console.log('searchCardBrand: _searchCardIssuer: ', this._searchCardIssuer);
    // console.log('searchCardBrand: _searchStatus: ', this._searchStatus);
    this._searchCardBrand = value;
    const filters = {
      prefix: [this._searchPrefix], // ['Blue', 'Black'],
      accountingNature: [this._searchAccountingNature], // [70, 50]
      cardBrand: [this._searchCardBrand],
      cardIssuer: [this._searchCardIssuer],
      status: [this._searchStatus]
    };
    this.filteredBines = this.filterBines();
  }

  get searchCardIssuer(): string {
    return this._searchCardIssuer;
  }

  set searchCardIssuer(value: string) {
    // console.log('searchCardIssuer: _searchPrefix: ', this._searchPrefix);
    // console.log('searchCardIssuer: _searchAccountingNature: ', this._searchAccountingNature);
    // console.log('searchCardIssuer: _searchCardBrand: ', this._searchCardBrand);
    // console.log('searchCardIssuer: _searchCardIssuer: ', value);
    // console.log('searchCardIssuer: _searchStatus: ', this._searchStatus);
    this._searchCardIssuer = value;
    const filters = {
      prefix: [this._searchPrefix], // ['Blue', 'Black'],
      accountingNature: [this._searchAccountingNature], // [70, 50]
      cardBrand: [this._searchCardBrand],
      cardIssuer: [this._searchCardIssuer],
      status: [this._searchStatus]
    };
    this.filteredBines = this.filterBines();
  }

  get searchStatus(): string {
    return this._searchStatus;
  }

  set searchStatus(value: string) {
    // console.log('searchStatus: _searchPrefix: ', this._searchPrefix);
    // console.log('searchStatus: _searchAccountingNature: ', this._searchAccountingNature);
    // console.log('searchStatus: _searchCardBrand: ', this._searchCardBrand);
    // console.log('searchStatus: _searchCardIssuer: ', this._searchCardIssuer);
    // console.log('searchStatus: _searchStatus: ', value);
    this._searchStatus = value;

    const filters = {
      prefix: [this._searchPrefix], // ['Blue', 'Black'],
      accountingNature: [this._searchAccountingNature], // [70, 50]
      cardBrand: [this._searchCardBrand],
      cardIssuer: [this._searchCardIssuer],
      status: [this._searchStatus]
    };
    this.filteredBines = this.filterBines();
  }

  filterBines2(array, filters) {
    console.log('filterBines: array: ', array);
    console.log('filterBines: filters: ', filters);
    const filterKeys = Object.keys(filters);
    console.log('filterBines: filterKeys: ', filterKeys);
    // filters all elements passing the criteria
    return array.filter(item => {
      // console.log('filterBines: item: ', item);
      // dynamically validate all filter criteria
      return filterKeys.every(key => {
        // ignores an empty filter
        console.log('filterBines: filters[', key, '].length: ', filters[key].length);
        if (!filters[key].length) {
          return true;
        }
        // return filters[key].includes(item[key]);
        return filters[key].some(f => item[key].some(v => v.id === f));
      });
    });
  }

  filterBines() {
    console.log('filterBines: _searchPrefix: [', this._searchPrefix.trim(), ']');
    console.log('filterBines: _searchAccountingNature: [', this._searchAccountingNature, ']');
    console.log('filterBines: _searchCardBrand: [', this._searchCardBrand, ']');
    console.log('filterBines: _searchCardIssuer: [', this._searchCardIssuer, ']');
    console.log('filterBines: _searchStatus: [', this._searchStatus, ']');

    // console.log('filterBines: searchPrefixString: ', searchString);
    // typeof searchPrefixString === 'undefined' || searchPrefixString === '-1' ? ''
    // typeof searchAccountingNatureString === 'undefined' || searchAccountingNatureString === '-1' ? ''
    return this.bines.filter(
      bin =>
        (this._searchPrefix.trim() !== ' ' ? bin.prefix.toString().indexOf(this._searchPrefix) !== -1 : '') &&
        (this._searchAccountingNature.trim() !== ' '
          ? bin.accountingNature.indexOf(this._searchAccountingNature) !== -1
          : '') &&
        (this._searchCardBrand.trim() !== ' ' ? bin.cardBrand.indexOf(this._searchCardBrand) !== -1 : '') &&
        (this._searchCardIssuer.trim() !== ' '
          ? bin.cardIssuerId.toString().indexOf(this._searchCardIssuer) !== -1
          : '') &&
        (this._searchStatus.trim() !== ' ' ? bin.status.toString().indexOf(this._searchStatus) !== -1 : '')
    );
  }

  newBin(): void {
    this.parent.showEditBin = false;
    this.parent.showBines = false;
    this.parent.showAddBin = true;
  }

  ngOnInit(): void {
    this.spinner();
    this.service.getBines().subscribe(
      res => {
        this.bines = res;
        this.filteredBines = this.bines;
      },
      err => this.httpErrorValidator.validateError(err)
    );
  }

  edit(elemento, index: number) {
    console.log('Entrando: index: ', index);
    // console.log('Entrando: prefix: ', elemento.bines[index].prefix);
    // this.parent.editnumber = elemento.bines[index].prefix;
    console.log('Entrando: prefix: ', elemento.prefix);
    this.parent.editnumber = elemento.prefix;
    this.parent.showBines = false;
    this.parent.showAddBin = false;
    this.parent.showEditBin = true;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  public ngOnDestroy(): void {
    $('a[rel=bines]').removeClass('selected');
  }
}
